var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from 'inversify';
import * as Sentry from '@sentry/react';
import { User } from './logger.types';
import { Logger } from './logger';
let SentryLogger = class SentryLogger extends Logger {
    constructor(user) {
        super();
        this.user = user;
    }
    /**
     * Логирует сообщение об ошибке в Sentry
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции содержат данные, которые необходимо залогировать в Sentry
     */
    log(message, { level, tags, context }) {
        const scopeContext = Object.assign(Object.assign({ user: {
                id: this.user.getId() || 'empty',
            }, level }, (tags ? { tags } : {})), (context
            ? {
                contexts: context,
            }
            : {}));
        if (typeof message === 'string') {
            Sentry.captureMessage(message, scopeContext);
            return;
        }
        Sentry.captureException(message, scopeContext);
    }
};
SentryLogger = __decorate([
    injectable(),
    __param(0, inject(User)),
    __metadata("design:paramtypes", [Object])
], SentryLogger);
export { SentryLogger };
